module.exports = __webpack_public_path__ + "static/img/Page of Wands.a37a268.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Page of Wands.jpg
// module id = 1290
// module chunks = 0